<!-- muro -->
<div class="wall-bg">
  <h2 class="h-main h-main-medium corporate">{{ 'wall_content_title' | translate }}</h2>
  <p class="time-mesg info-text col-12">{{ 'wall_content_info' | translate }}</p>
  <div class="row">
    @if (markAsRead) {
      <div class="col-12 no-pd-right">
        <section class="new-message row">
          <p class="new-msg-title col-12">{{ 'wall_content_send_msg' | translate }}</p>
          <div class="col-12">
            <textarea
              id="wall-textarea"
              class="wall-new-msg"
              [formControl]="commentInput"
              name=""
              [placeholder]="'wall_content_placeholder_input' | translate"
              cols="30"
              rows="20"
              [maxlength]="maxComment"
            ></textarea>
          </div>
          <div class="col-md-12 msg-btn-group d-flex justify-content-end">
            @if (file || fileError) {
              <div>
                @if (file) {
                  <div>
                    <p>
                      <span class="attach-mesg"
                        ><span class="ic ic-attach"></span>{{ file?.name }} - {{ file?.size | fileSize: '1' }}
                        <a class="btn btn-03 delete-btn" href="javascript:;" (click)="file = null">
                          {{ 'wall_content_btn_delete' | translate }}</a
                        >
                      </span>
                    </p>
                  </div>
                }

                @if (fileError) {
                  <div>
                    <p class="has-error">{{ fileError?.msgError }}</p>
                  </div>
                }
              </div>
            }

            @if (!file && status >= minStatus) {
              <button
                id="wall-content-btn-upload-file"
                class="btn btn-03 add-msg-file"
                type="button"
                (click)="fileUpload.click()"
              >
                {{ 'wall_content_btn_attach' | translate }} <span class="ic ic-attachment"></span>
              </button>
            }
            <button id="wall-content-btn-send" class="btn btn-01 send-msg-btn" type="button" (click)="sendComment()">
              {{ 'wall_content_btn_send' | translate }}
            </button>
            <app-upload-file
              #fileUpload
              hidden
              (onSendFile)="setFile($event)"
              (onErrorUploadFile)="setErrorFile($event)"
            ></app-upload-file>
          </div>
        </section>
      </div>
    }
  </div>

  @if (!error) {
    <div class="row">
      <div class="wall-border col-12 no-pd">
        <!-- <section class="wall" *ngIf="listComment" infiniteScroll [infiniteScrollDistance]="2" [scrollWindow]="false" [infiniteScrollThrottle]="10" (scrolled)="getComments()"> -->

        @if (listComment) {
          <section class="wall">
            @if (listComment.length === 0) {
              <div>
                <div class="message agent">
                  <!-- <div class="message agent" *ngIf="i % 2 == 0"> -->
                  <p class="msg-title col-12 corporate">{{ 'wall_content_list_empty_title' | translate }}</p>
                  <div class="msg-content col-12 row">
                    <div class="col-12 col-lg-9">
                      <p>
                        {{ 'wall_content_list_empty_msg' | translate }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            }
            <div *ngFor="let comment of listComment; let i = index">
              @if (comment?.createdBy !== 'Cliente') {
                <div class="message agent">
                  <!-- <div class="message agent" *ngIf="i % 2 == 0"> -->
                  <p class="msg-title col-12 col-lg-9">
                    {{ 'wall_content__message_manager' | translate }}
                    <span class="date-msg"> {{ comment?.createdDate | date: 'dd MMMM yyyy - HH:mm' }} </span>
                  </p>
                  <div class="msg-content col-12 row">
                    <div class="col-2 col-lg-1 no-pd profile-col">
                      <div class="profile-icon">
                        <img src="../assets/img/gestor.png" [alt]="'wall_content_send_by_you' | translate" />
                      </div>
                    </div>
                    <div class="col-12 col-lg-9 agent-msg">
                      <p class="text-msg" [innerHTML]="comment?.text" style="white-space: pre-line"></p>
                    </div>
                  </div>
                </div>
              }

              @if (comment?.createdBy === 'Cliente') {
                <div class="message user">
                  <!-- <div class="message user" *ngIf="i % 2 == 0"> -->
                  <p class="msg-title col-12">
                    {{ 'wall_content_send_by_you' | translate }}
                    <span class="date-msg"> {{ comment?.createdDate | date: 'dd MMMM yyyy - HH:mm' }} </span>
                  </p>
                  <div class="msg-content row">
                    <div class="col-12 col-lg-9 user-msg">
                      <p class="text-msg" [innerHTML]="comment?.text" style="white-space: pre-line"></p>
                    </div>
                    <div class="col-2 col-lg-1 no-pd profile-col">
                      <div class="profile-icon">
                        <img src="../assets/img/usuario.png" alt="'wall_content_send_by_you' | translate" />
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>

            @if (markAsRead) {
              <div class="show-more-btn">
                @if (!completeScroll && listComment?.length !== 0) {}
                <button id="wall-content-btn-get-more" class="btn btn-03 add-msg-file" (click)="getMoreComments()">
                  {{ 'wall_content_btn_get_more' | translate }}
                </button>
              </div>
            }
          </section>
        }
      </div>
    </div>
  } @else {
    <div class="row">
      <div class="wall-border col-12 no-pd-right">
        <section class="wall">
          <div>
            <div class="message agent">
              <p class="msg-title col-12 corporate has-error">{{ 'wall_content_error_title' | translate }}</p>
              <div class="msg-content">
                <div class="row">
                  <div class="col-12 col-10 col-lg-10">
                    <p class="has-error">
                      {{ 'wall_content_error_msg' | translate }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  }
</div>
